import BaseModalView from "scripts/views/baseModalView";
import template from "templates/chaptersDownloadModal.hbs";

import { getDownloadUrl } from "scripts/utils/mediaHelpers";

class ChaptersDownloadModalView extends BaseModalView {
  get template() {
    return template;
  }

  constructor(options) {
    super(options);

    this.compoundChildrenCollection = options.compoundChildrenCollection;
  }

  render() {
    const chapterData = this.compoundChildrenCollection.map(mediaModel => {
      return {
        title: mediaModel.get("title"),
        downloadUrl: getDownloadUrl(mediaModel)
      };
    });

    this.$el.html(
      this.template({
        chapterData,
      }),
    );

    return this;
  }
}

export default ChaptersDownloadModalView;
